import { createTheme, alpha, lighten } from '@mui/material/styles';

// Nexa font stack — loaded via @font-face in public/index.html (Nexa-Heavy / Nexa-ExtraLight).
// Used for page titles and the intro/login branding to keep a consistent voice.
export const NEXA_FONT = '"Nexa", "Roboto", "Helvetica", "Arial", sans-serif';

// A custom theme for this app
export const createAppTheme = (mode = 'light') => {
  const isDark = mode === 'dark';
  const switchCheckedColor = isDark ? lighten('#238048', 0.45) : '#238048';
  const switchCheckedTrack = isDark ? alpha(switchCheckedColor, 0.6) : alpha('#238048', 0.35);
  const switchTrackBase = isDark ? alpha('#f8fafc', 0.28) : undefined;

  return createTheme({
    palette: {
      mode,
      background: {
        default: isDark ? '#0b1220' : '#FCFDFF',
        paper: isDark ? '#0f172a' : '#ffffff',
      },
      text: {
        primary: isDark ? '#f8fafc' : '#021545',
        secondary: isDark ? 'rgba(248,250,252,0.70)' : 'rgba(2,21,69,0.55)',
      },
      primary: {
        main: isDark ? '#4871e6' : '#031444',
      },
      secondary: {
        main: '#238048',
      },
      action: {
        hover: '#38C76C',
      },
      error: {
        main: "#c92c51",
      },
      info: {
        main: '#4871e6',
      },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: isDark ? 'rgba(248,250,252,0.80)' : '#000000',
          },
        },
      },
      MuiSwitch: {
        styleOverrides: {
          track: {
            opacity: 1,
            backgroundColor: switchTrackBase,
          },
          switchBase: {
            '&.Mui-checked': {
              color: switchCheckedColor,
              '& + .MuiSwitch-track': {
                backgroundColor: switchCheckedTrack,
                opacity: 1,
              },
            },
          },
        },
      },
      MuiButton: {
        defaultProps: {
          disableElevation: true
        },
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        }
      },
    },
  });
};

export default createAppTheme('light');